import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function usePlans(affiliateId) {
  const [loading, setLoading] = useState(true);
  const [plans, setPlans] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.affiliates.plans(affiliateId))
      .then((response) => {
        setPlans(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, plans };
}
